export default __webpack_public_path__ + "static/media/005-measuring cup.6c15bef4.svg";